import { productOption } from "@/views/productDaily/components/instruction/option";

export const modelSpecificationsOption = [
    {
        label: "天鹅600",
        value: "Swan 600",
        children: [
            {
                label: 'Swan 600',
                value: 'Swan600',

            },
            {
                label: 'Swan 610E',
                value: 'Swan610E',

            },
            {
                label: 'Swan 620E',
                value: 'Swan620E',

            },
            {
                label: 'Swan 610S',
                value: 'Swan610S',

            },
            {
                label: 'Swan 620S',
                value: 'Swan620S',

            },
            {
                label: 'Swan 650M',
                value: 'Swan650M',

            },
            {
                label: 'Swan 660M',
                value: 'Swan660M',

            },
        ]
    },
    {
        label: "天鹅600P",
        value: "Swan 600P",
        children: [
            {
                label: 'Swan 600P',
                value: 'Swan600P',
            },
            {
                label: 'Swan 630E',
                value: 'Swan630E',
            },
            {
                label: 'Swan 660E',
                value: 'Swan660E',
            },
            {
                label: 'Swan 630S',
                value: 'Swan630S',
            },
            {
                label: 'Swan 650S',
                value: 'Swan650S',
            },
            {
                label: 'Swan 660S',
                value: 'Swan660S',
            },
            {
                label: 'Swan 670M',
                value: 'Swan670M',
            },
            {
                label: 'Swan 680M',
                value: 'Swan680M',
            },
            {
                label: 'Swan 690M',
                value: 'Swan690M',
            },
        ]
    },
    {
        label: "天鹅700",
        value: 'Swan 700',
        children: [
            {
                label: 'Swan 700',
                value: 'Swan700',
            },
            {
                label: 'Swan 710E',
                value: 'Swan710E',
            },
            {
                label: 'Swan 720E',
                value: 'Swan720E',
            },
            {
                label: 'Swan 710S',
                value: 'Swan710S',
            },
            {
                label: 'Swan 720S',
                value: 'Swan720S',
            },
            {
                label: 'Swan 750M',
                value: 'Swan750M',
            },
            {
                label: 'Swan 760M',
                value: 'Swan760M',
            },
        ]
    },
    {
        label: "天鹅700P",
        value: "Swan 700P",
        children: [
            {
                label: 'Swan 700P',
                value: 'Swan700P',
            },
            {
                label: 'Swan 730E',
                value: 'Swan730E',
            },
            {
                label: 'Swan 760E',
                value: 'Swan760E',
            },
            {
                label: 'Swan 730S',
                value: 'Swan730S',
            },
            {
                label: 'Swan 750S',
                value: 'Swan750S',
            },
            {
                label: 'Swan 760S',
                value: 'Swan760S',
            },
            {
                label: 'Swan 770M',
                value: 'Swan770M',
            },
            {
                label: 'Swan 780M',
                value: 'Swan780M',
            },
            {
                label: 'Swan 790M',
                value: 'Swan790M',
            },
        ]
    }
];

export const checkTypeInProject = (type) => {
    return modelSpecificationsOption.find((f) => {
        const item = f.children.find((child) => child.value === type);

        if (item) return f;
        return null;
    });
}

export const questionTypeOption = [
    {
        label: "物料导致",
        value: "物料导致",
    },
    {
        label: "人为导致",
        value: "人为导致",
    },
    {
        label: "半成品",
        value: "半成品",
    },
    {
        label: "软件导致",
        value: "软件导致",
    },
    {
        label: "其他",
        value: "其他"
    }
]

export const PQCProductOption = [
    {
        label: "三大件",
        value: "threeMajorItems",
    },
    {
        label: "束腰",
        value: "girdling",
    },
    {
        label: "波形调试",
        value: "referenceArm",
    },
    {
        label: "绕光纤参考臂",
        value: "fiberOpticReferenceArm",
    },
    {
        label: "探测器",
        value: "detector",
    },
    {
        label: "完整参考臂",
        value: "completeReferenceArm",
    },
    {
        label: "定标",
        value: "calibrate",
    },
    {
        label: "总装调试",
        value: "assembleDebug",
    },
    {
        label: "成品",
        value: "fqc",
    }, {
        label: "包装",
        value: 'oqc'
    }
];

export const getProcessName = (type: string) => {
    const base = [
        {
            label: "固定底座",
            value: "fixedbase",
        },
        {
            label: "运动底座",
            value: "sportsBase",
        },
        {
            label: "手柄",
            value: "handle",
        },
    ]
    const process = [...base, ...PQCProductOption].find((f: { value: string }) => f.value === type);

    if (!process) return '';

    return process.label
};

export const getPQCProductOption = () => {
    return JSON.parse(JSON.stringify(PQCProductOption));
};

// 年选项
export const yearOption = [];

const recordStartYear = 2023;

export const currentYear = new Date().getFullYear();

const setYearOption = () => {
    for (let i = recordStartYear; i <= currentYear; i += 1) {
        yearOption.push({
            label: i,
            value: i
        })
    }
};

setYearOption();


